import { Store, combineReducers, createStore, applyMiddleware } from 'redux'
import ReduxThunk from 'redux-thunk'

// User Reducers
import { AlertState } from 'util/modules/Alert/redux/types'
import { UserState } from 'panel/user/redux/types'
import { DocumentState } from 'panel/user/document/redux/types'
import { ContactState } from 'panel/user/contact/redux/types'
import { AddressState } from 'panel/user/address/redux/types'

import alertReducer from './util/modules/Alert/redux/reducer'
import userReducer from 'panel/user/redux/reducer'
import userDocumentReducer from 'panel/user/document/redux/reducer'
import userContactReducer from 'panel/user/contact/redux/reducer'
import userAddressReducer from 'panel/user/address/redux/reducer'

// App Reducers
import { CategoryState } from 'panel/category/redux/types'
import { ProductState } from 'panel/product/redux/types'
import { PartnerState } from 'panel/partner/redux/types'
import { PartnerDeliveryConfigState } from 'panel/partner/delivery/redux/types'
import { PartnerStaffState } from 'panel/partner/staff/redux/types'
import { PartnerProductState } from 'panel/partner/product-config/redux/types'
import { OrderStatusState } from 'panel/order-status/redux/types'
import { NotificationState } from 'panel/notification/redux/types'
import { BalanceState } from 'panel/balance/redux/types'
import { OrderState } from 'panel/order/redux/types'

import categoryReducer from 'panel/category/redux/reducer'
import productReducer from 'panel/product/redux/reducer'
import partnerReducer from 'panel/partner/redux/reducer'
import partnerDeliveryConfigReducer from 'panel/partner/delivery/redux/reducer'
import partnerStaffReducer from 'panel/partner/staff/redux/reducer'
import partnerProductReducer from 'panel/partner/product-config/redux/reducer'
import orderStatusReducer from 'panel/order-status/redux/reducer'
import notificationReducer from 'panel/notification/redux/reducer'
import balanceReducer from 'panel/balance/redux/reducer'
import orderReducer from 'panel/order/redux/reducer'

const reducers = combineReducers({
  alertReducer,
  userReducer,
  userDocumentReducer,
  userContactReducer,
  userAddressReducer,

  categoryReducer,
  productReducer,
  partnerReducer,
  partnerDeliveryConfigReducer,
  partnerStaffReducer,
  partnerProductReducer,
  orderStatusReducer,
  notificationReducer,
  balanceReducer,
  orderReducer
})

export interface ApplicationState {
  alertReducer: AlertState,
  userReducer: UserState,
  userDocumentReducer: DocumentState,
  userContactReducer: ContactState,
  userAddressReducer: AddressState,

  categoryReducer: CategoryState,
  productReducer: ProductState,
  partnerReducer: PartnerState,
  partnerDeliveryConfigReducer: PartnerDeliveryConfigState,
  partnerStaffReducer: PartnerStaffState,
  partnerProductReducer: PartnerProductState,
  orderStatusReducer: OrderStatusState,
  notificationReducer: NotificationState,
  balanceReducer: BalanceState,
  orderReducer: OrderState
}

const store: Store<ApplicationState> = createStore(reducers, {}, applyMiddleware(ReduxThunk))

export default store
